export const YANDEX_METRIKA_COUNTER_ID = '94081487';

const METRIKA_SCRIPT_SRC = 'https://mc.yandex.ru/metrika/tag.js';

interface YandexMetrikaFn {
  (...args: unknown[]): void;
  a?: unknown[][];
  l?: number;
}

declare global {
  interface Window {
    ym?: YandexMetrikaFn;
  }
}

let isInitialized = false;

export const initYandexMetrika = (): void => {
  if (typeof window === 'undefined' || isInitialized) return;
  isInitialized = true;

  if (!window.ym) {
    const stub: YandexMetrikaFn = (...args: unknown[]) => {
      (stub.a = stub.a || []).push(args);
    };
    stub.l = Date.now();
    window.ym = stub;
  }

  const isScriptPresent = Array.from(document.scripts).some(
    (script) => script.src === METRIKA_SCRIPT_SRC,
  );

  if (!isScriptPresent) {
    const script = document.createElement('script');
    script.async = true;
    script.src = METRIKA_SCRIPT_SRC;
    document.head.appendChild(script);
  }

  window.ym(YANDEX_METRIKA_COUNTER_ID, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
    triggerEvent: true,
  });
};

export const reachMetrikaGoal = (goalName: string): void => {
  if (typeof window === 'undefined' || !window.ym) return;
  window.ym(YANDEX_METRIKA_COUNTER_ID, 'reachGoal', goalName);
};
